"use client";

import { useBranchIORender } from "@/hooks/useInitialRender";

export const BranchIOInitializer = () => {
  useBranchIORender();
  return null;
};
